import { render, staticRenderFns } from "./IconAI.vue?vue&type=template&id=31214a1a&scoped=true"
var script = {}
import style0 from "./IconAI.vue?vue&type=style&index=0&id=31214a1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31214a1a",
  null
  
)

export default component.exports